<div class="subscriptions-container">
  <!-- Loading Overlay -->
  <app-loading 
    [isLoading]="(loading$ | async) || false" 
    [overlay]="true"
    message="Loading subscriptions..."
    size="large">
  </app-loading>

  <!-- List View Header -->
  <div class="header-section" *ngIf="!showDetails">
    <h2>Agent Subscriptions</h2>
    <a routerLink="/subscriptions/create" class="btn btn-primary">
      <i class="fas fa-plus"></i> Create Subscription
    </a>
  </div>

  <!-- Detail View Header -->
  <div class="header-section" *ngIf="showDetails">
    <div class="d-flex justify-content-between align-items-center">
      <h2>Subscription Details</h2>
      <button class="btn btn-outline-secondary" (click)="backToList()">
        <i class="fas fa-arrow-left"></i> Back to List
      </button>
    </div>
  </div>

    <!-- Filters Section - Only show in List View -->
  <div class="filters-section" *ngIf="!showDetails">
    <div class="filter-row">
      <div class="filter-group">
        <label for="statusFilter">Status:</label>
                 <select id="statusFilter" [(ngModel)]="statusFilter" class="form-control">
           <option value="">All Status</option>
           <option value="Active">Active</option>
           <option value="Expired">Expired</option>
           <option value="Cancelled">Cancelled</option>
         </select>
       </div>
       
       <div class="filter-group">
         <label for="zoneFilter">Zone:</label>
         <input type="text" id="zoneFilter" [(ngModel)]="zoneFilter" placeholder="Filter by zone" class="form-control">
       </div>
       
       <div class="filter-group">
         <label for="agentFilter">Agent:</label>
         <input type="text" id="agentFilter" [(ngModel)]="agentFilter" placeholder="Filter by agent name" class="form-control">
       </div>
       
       <div class="filter-actions">
         <button class="btn btn-secondary" (click)="applyFilters()">Apply Filters</button>
         <button class="btn btn-outline-secondary" (click)="clearFilters()">Clear</button>
       </div>
     </div>
   </div>

    <!-- Subscriptions Table - Only show in List View -->
  <div class="table-container" *ngIf="!showDetails">
    <div class="table-responsive">
      <table class="table table-striped table-hover">
      <thead>
        <tr>
          <th>Agent</th>
          <th class="d-none d-lg-table-cell">Zone</th>
          <th class="d-none d-xl-table-cell">Cadence</th>
          <th>Status</th>
          <th>Amount</th>
          <th class="d-none d-xl-table-cell">Start</th>
          <th class="d-none d-xl-table-cell">End</th>
          <th>Actions</th>
        </tr>
      </thead>
      <tbody>
        <ng-container *ngIf="subscriptions$ | async as subscriptions">
          <tr *ngFor="let subscription of subscriptions.items" 
              (click)="toggleRow(subscription.subscriptionId)"
              class="clickable-row"
              [attr.data-subscription-id]="subscription.subscriptionId">
            <td>
              <div class="agent-info">
                <strong>{{ getAgentName(subscription.agentId) }}</strong>
                <small class="agent-id">{{ (subscription.agentId | slice:0:8) + (subscription.agentId.length > 8 ? '...' : '') }}</small>
              </div>
            </td>
            <td class="d-none d-lg-table-cell">{{ subscription.zoneName || getZoneName(subscription.zoneId) }}</td>
            <td class="d-none d-xl-table-cell">{{ getCadenceText(subscription.cadence) }}</td>
            <td>
              <span class="status-badge" [class]="getStatusClass(subscription.status)">
                {{ getStatusText(subscription.status) }}
              </span>
            </td>
            <td>
              <div class="amount-info">
                <div class="main-amount">{{ formatCurrency(subscription.amount, subscription.currency) }}</div>
              </div>
            </td>
            <td class="d-none d-xl-table-cell">{{ formatDate(subscription.startDate) }}</td>
            <td class="d-none d-xl-table-cell">{{ formatDate(subscription.endDate) }}</td>
            <td>
              <div class="action-buttons">
                <button class="btn btn-sm btn-outline-primary" 
                       (click)="openUpdateModal(subscription); $event.stopPropagation()"
                       title="Edit Subscription">
                 Edit
               </button>
              </div>
            </td>
          </tr>
        </ng-container>
      </tbody>
    </table>
    </div>
     
         <!-- No Data Message -->
    <div *ngIf="(subscriptions$ | async)?.items?.length === 0 && !((loading$ | async) || false)" class="no-data">
      <p>No subscriptions found.</p>
    </div>

    <!-- Loading State for Table -->
    <div *ngIf="(loading$ | async) || false" class="table-loading">
      <app-loading 
        [isLoading]="true"
        message="Loading subscriptions..."
        size="medium">
      </app-loading>
    </div>
   </div>

           <!-- Pagination - Only show in List View -->
    <div class="pagination-section" *ngIf="!showDetails && totalPages > 0">
      <app-pagination 
        [page]="currentPage"
        [totalPages]="totalPages"
        [pageSize]="pageSize"
        (pageChange)="onPageChange($event)"
        (pageSizeChange)="onPageSizeChange($event)">
      </app-pagination>
    </div>

  <!-- Detail View - Only show when showDetails is true -->
  <div class="detail-view-container" *ngIf="showDetails && selectedSubscriptionForDetails">
    <div class="subscription-details">
      
      <!-- Basic Information Section -->
      <div class="detail-section">
        <h4>Subscription Information</h4>
        <div class="detail-grid">
          <div class="detail-item">
            <label>Subscription ID:</label>
            <span>{{ selectedSubscriptionForDetails.subscriptionId }}</span>
          </div>
          <div class="detail-item">
            <label>Agent:</label>
            <span>{{ getAgentName(selectedSubscriptionForDetails.agentId) }} ({{ selectedSubscriptionForDetails.agentId }})</span>
          </div>
          <div class="detail-item">
            <label>Zone:</label>
            <span>{{ selectedSubscriptionForDetails.zoneName || getZoneName(selectedSubscriptionForDetails.zoneId) }}</span>
          </div>
          <div class="detail-item">
            <label>Type:</label>
            <span>{{ getTypeText(selectedSubscriptionForDetails.type) }}</span>
          </div>
          <div class="detail-item">
            <label>Cadence:</label>
            <span>{{ getCadenceText(selectedSubscriptionForDetails.cadence) }}</span>
          </div>
          <div class="detail-item">
            <label>Status:</label>
            <span class="status-badge" [class]="getStatusClass(selectedSubscriptionForDetails.status)">
              {{ getStatusText(selectedSubscriptionForDetails.status) }}
            </span>
          </div>
          <div class="detail-item">
            <label>Start Date:</label>
            <span>{{ formatDate(selectedSubscriptionForDetails.startDate) }}</span>
          </div>
          <div class="detail-item">
            <label>End Date:</label>
            <span>{{ formatDate(selectedSubscriptionForDetails.endDate) }}</span>
          </div>
          <div class="detail-item">
            <label>Created:</label>
            <span>{{ formatDate(selectedSubscriptionForDetails.createdDate) }}</span>
          </div>
          <div class="detail-item">
            <label>Last Updated:</label>
            <span>{{ selectedSubscriptionForDetails.updatedDate ? formatDate(selectedSubscriptionForDetails.updatedDate) : 'Never' }}</span>
          </div>
        </div>
      </div>

      <!-- Payment Information Section -->
      <div class="detail-section">
        <h4>Payment Information</h4>
        <div class="detail-grid">
          <div class="detail-item">
            <label>Base Amount:</label>
            <span>{{ formatCurrency(selectedSubscriptionForDetails.baseAmount, selectedSubscriptionForDetails.currency) }}</span>
          </div>
          <div class="detail-item" *ngIf="hasDiscount(selectedSubscriptionForDetails)">
            <label>Discount:</label>
            <span>
              {{ selectedSubscriptionForDetails.discountPercentage }}% 
              ({{ formatCurrency(selectedSubscriptionForDetails.discountAmount, selectedSubscriptionForDetails.currency) }})
            </span>
          </div>
          <div class="detail-item">
            <label>Final Amount:</label>
            <span class="highlight-amount">{{ formatCurrency(selectedSubscriptionForDetails.amount, selectedSubscriptionForDetails.currency) }}</span>
          </div>
          <div class="detail-item">
            <label>Payment Status:</label>
            <span class="status-badge" [class]="getPaymentStatusClass(selectedSubscriptionForDetails.paymentStatus)">
              {{ getPaymentStatusText(selectedSubscriptionForDetails.paymentStatus) }}
            </span>
          </div>
          <div class="detail-item">
            <label>Payment Method:</label>
            <span>{{ getPaymentMethodText(selectedSubscriptionForDetails.paymentMethod) }}</span>
          </div>
          <div class="detail-item">
            <label>Payment Date:</label>
            <span>{{ formatDate(selectedSubscriptionForDetails.paymentDate) }}</span>
          </div>
          <div class="detail-item" *ngIf="selectedSubscriptionForDetails.paymentReference">
            <label>Payment Reference:</label>
            <span>{{ selectedSubscriptionForDetails.paymentReference }}</span>
          </div>
          <div class="detail-item" *ngIf="selectedSubscriptionForDetails.verifiedBy">
            <label>Verified By:</label>
            <span>{{ selectedSubscriptionForDetails.verifiedBy }}</span>
          </div>
        </div>
      </div>



      <!-- Notes Section -->
      <div class="detail-section" *ngIf="selectedSubscriptionForDetails.notes">
        <h4>Notes</h4>
        <div class="notes-content">
          <p>{{ selectedSubscriptionForDetails.notes }}</p>
        </div>
      </div>
    </div>
      
    <!-- Action buttons in detail view -->
    <div class="detail-actions">
      <button class="btn btn-outline-primary" 
              (click)="openUpdateModal(selectedSubscriptionForDetails!)">
        Edit Subscription
      </button>
    </div>
  </div>



<!-- Update Subscription Modal -->
<div class="modal-overlay" *ngIf="showUpdateModal" (click)="closeUpdateModal()">
  <div class="modal-content" (click)="$event.stopPropagation()">
    <app-update-subscription 
      [subscription]="selectedSubscription!"
      (subscriptionUpdated)="onSubscriptionUpdated()"
      (modalClosed)="closeUpdateModal()">
    </app-update-subscription>
  </div>
</div>
